import React, { Ref } from "react";
import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
import { ArticleSection, LoadingSection } from "@domain/lms/article/article";
import { gap } from "@ui/styles/utils";
import { SectionEditor } from "@ui/pages/lms/article/articleEditorPage/sectionEditor/sectionEditor";

interface ArticleSectionEditorProps extends React.HTMLAttributes<HTMLDivElement> {
	section: ArticleSection | LoadingSection;
	droppableRef: Ref<HTMLDivElement | null>;
	sectionPlaceholder?: React.ReactNode;
	index: number;
}
export const ArticleSectionEditor: React.FC<ArticleSectionEditorProps> = ({
	section,
	droppableRef,
	sectionPlaceholder,
	index,
	...htmlProps
}) => {
	return (
		<Container {...htmlProps} ref={droppableRef}>
			<Draggable key={section.id} draggableId={section.id} index={index}>
				{(provided, snapshot) => (
					<div ref={provided.innerRef} {...provided.draggableProps}>
						<SectionEditor
							section={section}
							style={snapshot.isDragging ? { boxShadow: "0 22px 94px 0 rgba(0, 0, 0, 0.15)" } : {}}
						/>
						<DragIcon {...provided.dragHandleProps}>
							<div />
							<div />
						</DragIcon>
					</div>
				)}
			</Draggable>
			{sectionPlaceholder}
		</Container>
	);
};

const Container = styled.div``;

const DragIcon = styled.div`
	width: 30px;
	padding: 5px;
	${gap(5)};

	margin: 5px auto;
	> div {
		background-color: ${({ theme }) => theme.colors.lightgray};
		height: 1px;
	}
`;
